import script from "./WholePieceReadcodeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./WholePieceReadcodeTable.vue?vue&type=script&setup=true&lang=js"

import "./WholePieceReadcodeTable.vue?vue&type=style&index=0&id=531bccc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531bccc9"]])

export default __exports__